module.exports = __webpack_public_path__ + "static/media/ETH-BRL.3ba0b820.svg";